import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import DeXuatMuaSamService from "services/Asset/DeXuatMuaSamService";

export const GetAllDeXuatMuaSam = createAsyncThunk(
    "DeXuatMuaSam/GetAllDeXuatMuaSam",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetAllDeXuatMuaSam(data);
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const GetAllDeXuatMuaSamMp = createAsyncThunk(
    "DeXuatMuaSam/GetAllDeXuatMuaSamMp",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetAllDeXuatMuaSamMp(data);
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const GetAllTongHopDeXuatMuaSam = createAsyncThunk(
    "DeXuatMuaSam/GetAllTongHopDeXuatMuaSam",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetAllTongHopDeXuatMuaSam(data);
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);
export const GetDeXuatMuaSam = createAsyncThunk(
    "DeXuatMuaSam/GetDeXuatMuaSam",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetDeXuatMuaSam(data);
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const GetTongHopDeXuatMuaSam = createAsyncThunk(
    "DeXuatMuaSam/GetTongHopDeXuatMuaSam",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetTongHopDeXuatMuaSam(data);
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);
export const UpsertDeXuatMuaSam = createAsyncThunk(
    "DeXuatMuaSam/UpsertDeXuatMuaSam",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await DeXuatMuaSamService.UpsertDeXuatMuaSam(data);
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);


export const UpsertTrangThaiDx = createAsyncThunk(
    "DeXuatMuaSam/UpsertTrangThaiDx",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await DeXuatMuaSamService.UpsertTrangThaiDx(data);
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);

export const DeleteDeXuatMuaSam = createAsyncThunk(
    "DeXuatMuaSam/DeleteDeXuatMuaSam",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await DeXuatMuaSamService.DeleteDeXuatMuaSam(
                payload.id
            );
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);

export const DeleteTongHopDeXuatMuaSam = createAsyncThunk(
    "DeXuatMuaSam/DeleteTongHopDeXuatMuaSam",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await DeXuatMuaSamService.DeleteTongHopDeXuatMuaSam(
                payload.id
            );
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);

export const GetDeXuatMuaSamChiTiet = createAsyncThunk(
    "DeXuatMuaSam/GetDeXuatMuaSamChiTiet",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetDeXuatMuaSamChiTiet(
                data
            );
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const GetAllChuaTongHopChiTiet = createAsyncThunk(
    "DeXuatMuaSam/GetAllChuaTongHopChiTiet",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetAllChuaTongHopChiTiet(
                data
            );
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const GetAllTongHopChiTiet = createAsyncThunk(
    "DeXuatMuaSam/GetAllTongHopChiTiet",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetAllTongHopChiTiet(
                data
            );
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const UpsertDeXuatMuaSamChiTiet = createAsyncThunk(
    "DeXuatMuaSam/UpsertDeXuatMuaSamChiTiet",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response =
                await DeXuatMuaSamService.UpsertDeXuatMuaSamChiTiet(data);
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);

export const DeleteDeXuatMuaSamChiTiet = createAsyncThunk(
    "DeXuatMuaSam/DeleteDeXuatMuaSamChiTiet",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response =
                await DeXuatMuaSamService.DeleteDeXuatMuaSamChiTiet(payload.id);
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);

export const GetListTaiSanByLoaiDC = createAsyncThunk(
    "DeXuatMuaSam/GetListTaiSanByLoaiDC",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetListTaiSanByLoaiDC(data);
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const GetAllTaiSan = createAsyncThunk(
    "DeXuatMuaSam/GetAllTaiSan",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetAllTaiSan();
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const GetAllChuaTongHop = createAsyncThunk(
    "DeXuatMuaSam/GetAllChuaTongHop",
    async (data, { rejectWithValue }) => {
        try {
            const response = await DeXuatMuaSamService.GetAllChuaTongHop(data);
            return response.data;
        } catch (err) {
            console.error("API call failed:", err);
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const UpsertTongHopDeXuatMuaSam = createAsyncThunk(
    "DeXuatMuaSam/UpsertTongHopDeXuatMuaSam",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await DeXuatMuaSamService.UpsertTongHopDeXuatMuaSam(data);
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);


export const ExportTongHopDxms = createAsyncThunk(
    "DeXuatMuaSam/ExportTongHopDxms",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await DeXuatMuaSamService.ExportTongHopDxms(payload);
            if (onSuccess) onSuccess(response);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const IsTongHopChiTiet = createAsyncThunk(
    "DeXuatMuaSam/IsTongHopChiTiet",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await DeXuatMuaSamService.IsTongHopChiTiet(data);
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);

export const UpdateTongHopChiTiet = createAsyncThunk(
    "DeXuatMuaSam/UpdateTongHopChiTiet",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await DeXuatMuaSamService.UpdateTongHopChiTiet(data);
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);


export const UpdateTrangThaiTongHopChiTiet = createAsyncThunk(
    "DeXuatMuaSam/UpdateTrangThaiTongHopChiTiet",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const { onSuccess } = data;
            const payload = cloneDeep(data);
            delete payload.onSuccess;
            const response = await DeXuatMuaSamService.UpdateTrangThaiTongHopChiTiet(data);
            if (onSuccess) onSuccess(response);

            return response.data;
        } catch (error) {
            console.error("API call failed:", error);
            return rejectWithValue(error.message || "Error");
        }
    }
);
const initialState = {
    loading: false,
    DeXuatMuaSamList: [],
    DeXuatMuaSamMpList: [],
    DeXuatMuaSamDetail: {},
    DeXuatMuaSamChiTietList: [],
    TaiSanByLoaiDCList: [],
    AllTaiSanList: [],
    TongHopDeXuatMuaSamList: [],
    TongHopDeXuatMuaSamDetail: {},
    ChuaTongHopDeXuatMuaSamList: [],
    TongHopDeXuatMuaSamChiTietList: [],
    AllDeXuatTongHopList: []
};

const DeXuatMuaSamSlice = createSlice({
    name: "DeXuatMuaSam",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            //GetAllChuaTongHop
            .addCase(GetAllChuaTongHop.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetAllChuaTongHop.fulfilled, (state, action) => {
                state.loading = false;
                state.AllDeXuatTongHopList = action.payload;
            })
            .addCase(GetAllChuaTongHop.rejected, (state) => {
                state.loading = false;
            })
            //GetAllTongHopChiTiet
            .addCase(GetAllTongHopChiTiet.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetAllTongHopChiTiet.fulfilled, (state, action) => {
                state.loading = false;
                state.TongHopDeXuatMuaSamChiTietList = action.payload;
            })
            .addCase(GetAllTongHopChiTiet.rejected, (state) => {
                state.loading = false;
            })
            //GetAllChuaTongHopChiTiet
            .addCase(GetAllChuaTongHopChiTiet.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetAllChuaTongHopChiTiet.fulfilled, (state, action) => {
                state.loading = false;
                state.ChuaTongHopDeXuatMuaSamList = action.payload;
            })
            .addCase(GetAllChuaTongHopChiTiet.rejected, (state) => {
                state.loading = false;
            })
            //GetTongHopDeXuatMuaSam
            .addCase(GetTongHopDeXuatMuaSam.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetTongHopDeXuatMuaSam.fulfilled, (state, action) => {
                state.loading = false;
                state.TongHopDeXuatMuaSamDetail = action.payload;
            })
            .addCase(GetTongHopDeXuatMuaSam.rejected, (state) => {
                state.loading = false;
            })
            //GetAllTongHopDeXuatMuaSam
            .addCase(GetAllTongHopDeXuatMuaSam.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetAllTongHopDeXuatMuaSam.fulfilled, (state, action) => {
                state.loading = false;
                state.TongHopDeXuatMuaSamList = action.payload;
            })
            .addCase(GetAllTongHopDeXuatMuaSam.rejected, (state) => {
                state.loading = false;
            })
            //GetAllDeXuatMuaSamMp
            .addCase(GetAllDeXuatMuaSamMp.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetAllDeXuatMuaSamMp.fulfilled, (state, action) => {
                state.loading = false;
                state.DeXuatMuaSamMpList = action.payload;
            })
            .addCase(GetAllDeXuatMuaSamMp.rejected, (state) => {
                state.loading = false;
            })
            //GetAllTaiSan
            .addCase(GetAllTaiSan.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetAllTaiSan.fulfilled, (state, action) => {
                state.loading = false;
                state.AllTaiSanList = action.payload;
            })
            .addCase(GetAllTaiSan.rejected, (state) => {
                state.loading = false;
            })
            //GetListTaiSanByLoaiDC
            .addCase(GetListTaiSanByLoaiDC.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetListTaiSanByLoaiDC.fulfilled, (state, action) => {
                state.loading = false;
                state.TaiSanByLoaiDCList = action.payload;
            })
            .addCase(GetListTaiSanByLoaiDC.rejected, (state) => {
                state.loading = false;
            })
            //GetDeXuatMuaSamChiTiet
            .addCase(GetDeXuatMuaSamChiTiet.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetDeXuatMuaSamChiTiet.fulfilled, (state, action) => {
                state.loading = false;
                state.DeXuatMuaSamChiTietList = action.payload;
            })
            .addCase(GetDeXuatMuaSamChiTiet.rejected, (state) => {
                state.loading = false;
            })
            //GetDeXuatMuaSam
            .addCase(GetDeXuatMuaSam.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetDeXuatMuaSam.fulfilled, (state, action) => {
                state.loading = false;
                state.DeXuatMuaSamDetail = action.payload;
            })
            .addCase(GetDeXuatMuaSam.rejected, (state) => {
                state.loading = false;
            })
            //GetAllDeXuatMuaSam
            .addCase(GetAllDeXuatMuaSam.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetAllDeXuatMuaSam.fulfilled, (state, action) => {
                state.loading = false;
                state.DeXuatMuaSamList = action.payload;
            })
            .addCase(GetAllDeXuatMuaSam.rejected, (state) => {
                state.loading = false;
            });
    },
});
export const { showLoading, setHisInfo } = DeXuatMuaSamSlice.actions;

export default DeXuatMuaSamSlice.reducer;
